<template>
	<div>
		{{surveyResponses.length}}
	</div>
</template>
<script>
	import Vuex from "vuex"
	export default{
		name: "SurveyResponseCounter", 
		props: {
			survey: {type: Object}
		}, 
		computed: {
			...Vuex.mapState( {
				surveyResponses(state){
					var surveyId = this.survey.id
					return state.admin.surveyResponses.filter( a => a.survey == surveyId )
				}
			})
		},
		watch: {
			survey: {
				immediate: true, 
				handler(){
					if( !this.surveyResponses.length ){
						this.$store.dispatch("fetchSurveyResponses", this.survey.id )
					}
				}				
			}
		}
	}
</script>